import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsTable from "./en-us/table.json";
import localizationEnUsModal from "./en-us/modal.json";

export const localizationEnUsAccounts = {
  ...localizationEnUsHeader,
  ...localizationEnUsTable,
  ...localizationEnUsModal,
};
